import { useMemo } from 'react'
import cx from 'classnames'

import Avatar from 'components/Avatar'
import './style.scss'

type AvatarHorizontalListProps = {
  users?: any[]
  className?: string
  totalVisible?: number
}

const AvatarHorizontalList = ({
  className,
  users = [],
  totalVisible = 3,
}: AvatarHorizontalListProps) => {
  if (users?.length < 1) {
    return null
  }

  const visibleUsers = useMemo(() => {
    return users.slice(0, totalVisible).map((user) => user)
  }, [users])

  return (
    <div className={cx('AvatarHorizontalList', className)}>
      {visibleUsers.map((user) => (
        <div className="AvatarHorizontalList__item" key={user.id}>
          <Avatar user={user} />
        </div>
      ))}
      {users?.length > totalVisible && (
        <div className="AvatarHorizontalList__item AvatarHorizontalList__item--more">
          {users?.length - totalVisible}+
        </div>
      )}
    </div>
  )
}

export default AvatarHorizontalList
